import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        
        this.hasNumbers = this.el.classList.contains('-with-numbers');
        this.numbers = this.hasNumbers ? this.el.querySelectorAll('.c-quotes_number') : null;
        this.activeIndex = null;

        this.prevAnim = null;
        this.nextAnim = null;

        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            modules: [Navigation],
            autoHeight: true,
            navigation: {
                nextEl: this.el.querySelector('.c-quotes_next'),
                prevEl: this.el.querySelector('.c-quotes_prev'),
            }
        });

        if (this.hasNumbers) {
            this.showNumber(0);
            this.swiper.on('slideChange', (s) => {
                this.showNumber(s.activeIndex);
            });
        }
    }

    showNumber(index) {
        if (this.activeIndex == index) return;
        
        let prevWrap = null;
        
        if (this.activeIndex != index) {
            prevWrap = this.activeIndex != null ? this.numbers[this.activeIndex] : null;
            this.activeIndex = index;

            if (prevWrap) {
                prevWrap.classList.remove('-active');
            }
        }

        let wrap = this.numbers[this.activeIndex];
        wrap.classList.add('-active');
    }
}
